import { Tween } from "../../tween/Tween";
import { Gear } from "./Gear";
export class GearDisplay extends Gear {
    constructor() {
        super();
        this._flag = true;
        this._condition = 0;
        this._pages = [];
        this.propPath = "internalVisible";
    }
    get pages() {
        return this._pages;
    }
    set pages(value) {
        this._pages = value;
        this.onChanged(null);
    }
    get condition() {
        return this._condition;
    }
    set condition(value) {
        this._condition = value;
        this.onChanged(null);
    }
    runGear(initiator) {
        if (this._tween) {
            this._tween.kill();
            this._tween.recover();
            this._tween = null;
        }
        let page = this._controller.selectedIndex;
        this._flag = page == -1 || this._pages.length == 0 || this._pages.indexOf(page) != -1;
        if (initiator == null || !initiator.changing || this._owner.gears.length === 1)
            GearDisplay.check(this._owner, null, false);
        else
            pendings.add(this._owner);
    }
    static check(owner, cc, allowDelay) {
        var _a, _b;
        let r;
        let delay = 0;
        let gd;
        for (let g of owner.gears) {
            if (g instanceof GearDisplay) {
                if (r == null)
                    r = g._flag;
                else if (g._condition == 0)
                    r = r && g._flag;
                else
                    r = r || g._flag;
                gd = g;
            }
            else if (allowDelay && g._tween != null && ((_a = g.controller) === null || _a === void 0 ? void 0 : _a.inst) == cc) {
                delay = Math.max(delay, (_b = g._tween.findTweener(null)) === null || _b === void 0 ? void 0 : _b.remainTime);
            }
        }
        r = r !== null && r !== void 0 ? r : true;
        if (delay !== 0 && !r && owner.internalVisible != r) {
            gd._tween = Tween.create(owner).duration(delay).then(() => {
                owner.internalVisible = false;
                gd._tween.recover();
                gd._tween = null;
            });
        }
        else
            owner.internalVisible = r;
    }
    static checkAll(cc) {
        if (pendings.size == 0)
            return;
        for (let obj of pendings) {
            GearDisplay.check(obj, cc, true);
        }
        pendings.clear();
    }
}
const pendings = new Set();
